export default "/images/gfforsikring.webp?7d8ef1545d316ff867b659620327773c";